'use strict';

var React = require('react');

var SvgPhoneInMajor = function SvgPhoneInMajor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M16.094 9.1h-3.994a.996.996 0 0 1-.998-.998v-3.996a.997.997 0 0 1 1.705-.708.998.998 0 0 1 .293.707v1.585l3.335-3.334a.999.999 0 0 1 1.413 1.411l-3.336 3.334h1.584a.999.999 0 0 1 0 1.999zm-8.752-4.794.534 2.67a1.495 1.495 0 0 1-.802 1.634l-.975.488c0 2 3 5 5 5l.488-.975a1.5 1.5 0 0 1 1.636-.8l2.67.534a1.5 1.5 0 0 1 1.206 1.471v3.235c0 .859-.725 1.572-1.584 1.535-8.915-.388-13.954-4.251-14.414-14.412-.039-.859.677-1.586 1.537-1.586h3.233a1.5 1.5 0 0 1 1.471 1.206z"
  }));
};

exports.SvgPhoneInMajor = SvgPhoneInMajor;
